import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/src/locale/pt";
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1450,
      lg: 1920,
    },
  },
  icons: {
    iconfont: "fa",
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        black: "#272727",
        gray90: "#4A4A4A",
        gray70: "#979797",
        gray50: "#BBBBBB",
        gray15: "#F6F7FA",
        purple100: "#661F7C",
        purple70: "#AD92B8",
        purple40: "#E7DBEA",
        green100: "#8DC63F",
        greenCLevel: "#1A9A5B",
        redExecutive: "#C50000",
        redAlert: "#F1002E",
        waterProfile: "#78CCB3",
        redProfile: "#EE6F6F",
        orangeProfile: "#EEAC6F",
        yellowProfile: "#F2D589",
        greenProfile: "#A3D35D",
        blueProfile: "#86D5DA",
        purpleProfile: "#A686DA",
        pinkProfile: "#E47496",
        primary: "#661F7C",
        white: "#FFFFFF",
        bluePartner: "#2F396B",
        tagDarkBlue: "#112D78",
        tagOrange: "#BE6318",
        tagBlue: "#2F396B",
        tagGreen: "#1B6336",
        tagRed: "#B11A37",
        tagPurple: "#882CA5",
        grayTransmission: "#D8D8D8",
        redLight: "#FFE0E1",
        orangeNotification: "#FFA451",
        purpleSidebar: "#E284FF",
        blueSurvey: "#3E8FA5",
        greenSurvey: "#30A395",
        yellowSurvey: "#FA9C30",
        redLightSurvey: "#CF5555",
        purple100Survey: "#DDC1E6",
        cyanDarkSurvey: "#BAB8F5",
        greenLightSurvey: "#CEE3A9",
        greenDarkSurvey: "#1B6336",
        pinkSurvey: "#C67282",
        redDarkSurvey: "#7C1F3F",
        magentaSurvey: "#C63F81",
        pinkLight: "#F0CEFA",
        brownRanking: "#95673E",
        blueFraternal: "#74D0E9",
        gray35: "#E6E6E6",
        purpleHover: "#84329E",
        purpleDeep: "#49105A",
        purplePale: "#F5D7FF",
        purpleMedium: "#C566E2",
        infoBlue: "#57AFC7",
        tealFocus: "#00C9BA",
        teal200: "#03C9BA",
        gray5: "#F8F8F8",
        redPale: "#FFBEBE",
        redMuted: "#FF9494",
        redBright: "#FF4141",
        redDark: "#9C0000",
        redDeep: "#4B0000",
        purpleBrand: "#6F1780",
        purpleSecondary: "#886591",
        purpleShadow: "#A44AC0",
        orange40: "#FFE4C5",
        purple200: "#EFBBFF",
        purple10: "#F2E2F6",
        tealDark: "#3F8598",
        greenDark: "#1A9A5B",
        brownLight: "#BE6318",
        purple60: "#886491",
        purple15: "#FFE8FF",
        green60: "#49817B",
        cyanDark: "#00C9BA",
        cyanLight: "#C1FCF5",
        greenFeedback: "#4F7A1A",
        brownFeedback: "#A85A00",
        redFeedback: "#C50000",
        blueFeedback: "#297083",
        blackOriginal: "#000000",
        tealBorder: "#03C9BA",
      },
      dark: {
        black: "#FFFFFF",
        gray90: "#4A4A4A",
        gray70: "#979797",
        gray50: "#BBBBBB",
        gray15: "#F6F7FA",
        purple100: "#661F7C",
        purple70: "#AD92B8",
        purple40: "#E7DBEA",
        green100: "#8DC63F",
        greenCLevel: "#1A9A5B",
        redExecutive: "#C50000",
        redAlert: "#F1002E",
        waterProfile: "#78CCB3",
        redProfile: "#EE6F6F",
        orangeProfile: "#EEAC6F",
        yellowProfile: "#F2D589",
        greenProfile: "#A3D35D",
        blueProfile: "#86D5DA",
        purpleProfile: "#A686DA",
        pinkProfile: "#E47496",
        primary: "#661F7C",
        white: "#272727",
        bluePartner: "#2F396B",
        tagDarkBlue: "#112D78",
        tagOrange: "#BE6318",
        tagBlue: "#2F396B",
        tagGreen: "#1B6336",
        tagRed: "#B11A37",
        tagPurple: "#882CA5",
        grayTransmission: "#D8D8D8",
        redLight: "#FFE0E1",
        orangeNotification: "#FFA451",
        purpleSidebar: "#E284FF",
        blueSurvey: "#3E8FA5",
        greenSurvey: "#30A395",
        yellowSurvey: "#FA9C30",
        redLightSurvey: "#CF5555",
        purple100Survey: "#DDC1E6",
        cyanDarkSurvey: "#BAB8F5",
        greenLightSurvey: "#CEE3A9",
        greenDarkSurvey: "#1B6336",
        pinkSurvey: "#C67282",
        redDarkSurvey: "#7C1F3F",
        magentaSurvey: "#C63F81",
        pinkLight: "#F0CEFA",
        brownRanking: "#95673E",
        blueFraternal: "#74D0E9",
        gray35: "#E6E6E6",
        purpleHover: "#84329E",
        purpleDeep: "#49105A",
        purplePale: "#F5D7FF",
        purpleMedium: "#C566E2",
        infoBlue: "#57AFC7",
        tealFocus: "#00C9BA",
        teal200: "#03C9BA",
        gray5: "#F8F8F8",
        redPale: "#FFBEBE",
        redMuted: "#FF9494",
        redBright: "#FF4141",
        redDark: "#9C0000",
        redDeep: "#4B0000",
        purpleBrand: "#6F1780",
        purpleSecondary: "#886591",
        purpleShadow: "#A44AC0",
        orange40: "#FFE4C5",
        purple200: "#EFBBFF",
        purple10: "#F2E2F6",
        tealDark: "#3F8598",
        greenDark: "#1A9A5B",
        brownLight: "#BE6318",
        purple60: "#886491",
        purple15: "#FFE8FF",
        green60: "#49817B",
        cyanDark: "#00C9BA",
        cyanLight: "#C1FCF5",
        greenFeedback: "#4F7A1A",
        brownFeedback: "#A85A00",
        redFeedback: "#C50000",
        blueFeedback: "#297083",
        blackOriginal: "#000000",
        tealBorder: "#03C9BA",
      },
    },
  },
});
